//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Layout from '@components/Layout';
import {
  GlobalStyle,
  ModalBaileys,
  BailetsBlock,
  MenuWrap
} from './ModalStory.styles';
import { CloseVideoIcon, LogoMansion, LogoMartins } from '@assets/svgs';
import Footer from '@components/Footer';
import Menu from '@components/Menu';
import {
  TonyWardSS23,
  GeorgesChakraFW2324,
  ZiadNakadSS23,
  ChanelSS23,
  TonyWardRWSS24
} from '@components/ModalStory/data/fashion_writers';

type ReadProps = {
  showHChighlight?: boolean;
  isClosed?: () => void;
};

const Thestorymodal = ({ isClosed }: ReadProps) => {
  return (
    <>
      <GlobalStyle />
      <Layout showHeader showNoheader showMenu showTheStoryHeader>
        <ModalBaileys>
          <section>
            <BailetsBlock>
              <CloseVideoIcon
                animation="closeIcon"
                color="#000"
                isActive={isClosed}
              />
              <LogoMartins
                width={70}
                height={65}
                color="rgba(0,0,0,0.5)"
                animation="mansion"
              />

              <h3>THE STORY</h3>
              <span>Fashion Writers</span>
              <h4
                style={{
                  letterSpacing: '3px',
                  marginTop: '20px',
                  fontSize: '15px',
                  fontWeight: '900',
                  color: '#000',
                  textAlign: 'center'
                }}
              >
                GEORGE MARTIN'S
              </h4>
            </BailetsBlock>
            <BailetsBlock
              style={{
                height: '200px',
                justifyContent: 'center',
                padding: '20px'
              }}
            >
              <span style={{ marginBottom: '10px' }}>
                <b>For you..</b>
              </span>
              <span>Life is a runway.</span>
              <span>We're leaving on a Catwalk every single moment...</span>
            </BailetsBlock>

            <BailetsBlock style={{ justifyContent: 'center' }}>
              <span>The Fashion Book</span>
              <h2>AN ENDLESS STORY</h2>
              {/* <span>FALL / WINTER 23 - 24</span> */}

              <p className="topPargraph" style={{ marginTop: '50px' }}>
                {/* <span style={{ display: 'flex', justifyContent: 'center', marginBottom: '4px'}}>28 / 02 / 2024</span> */}
                <span
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    textTransform: 'uppercase',
                    marginBottom: '10px'
                  }}
                >
                  <b>We are Fashion Writers.</b>
                </span>
                Each collection is a fairytale with hundreds of luxury and
                elegant stories. If you were told the whole story, you would
                wish to fly to the 7th dimension, where everything is bright and
                glorious. Fashion is an untold story sometimes, and we exist to
                unwrap the untold story. To you dream about and to make your
                dream come true.
                <br />
                <br />
              </p>

              <TonyWardRWSS24 mT="70px" />
            </BailetsBlock>

            <BailetsBlock style={{ justifyContent: 'center' }}>
              <span>One</span>
              {/* <h2>THE NEXT SUMMER...</h2> */}
              
              <GeorgesChakraFW2324 mT="70px" />
              <TonyWardSS23 mT="70px" />
              <ChanelSS23 mT="70px" />
              <ZiadNakadSS23 mT="70px" />
            </BailetsBlock>

            <Footer mgT="40px" />
          </section>
        </ModalBaileys>
      </Layout>
    </>
  );
};

export default Thestorymodal;
